import React, { useMemo } from "react"

import { MobileNavigation, KioskNavigation } from "components/navigation"
import { useLocation } from "react-router-dom"
import config from "config"
import { useAppUI } from "providers/ui"
import _ from "lodash"

export const AppNavigation = () => {
  const location = useLocation()
  const {
    showBottomNavigation,
    mobileNavigations,
    mobileMainNavigations,
    kioskNavigation,
    navigations,
  } = useAppUI()
  const device = config("device") || "mobile"

  /** Find matched path to add "select" state to navs
   *  - add /* so that all sub-pages will match too, (eg. /maps/ordinal/1, /maps/place/:placeId will also set `/maps` to selected)
   */
  const orderedMenus = useMemo(
    () => _.orderBy(navigations, ["to"], ["desc"]),
    [navigations]
  )
  const matchPath = useMemo(() => {
    const { pathname: currentPathName, search = "" } = location
    const currentQueryParams = new URLSearchParams(search)
    return orderedMenus.find((nav) => {
      const [navPathname, navQueryString = ""] = nav.to.split("?")
      const navQueryParams = new URLSearchParams(navQueryString)
      const isMatchedPath = currentPathName.indexOf(navPathname) === 0

      if (!isMatchedPath) return false

      if (navQueryParams.size === 0) return isMatchedPath

      // If the config path includes a query string, we will prioritize matching the query string.
      for (const p of navQueryParams) {
        const [key, value] = p
        if (!currentQueryParams.has(key, value)) return false
      }

      return true
    })
  }, [orderedMenus, location])

  switch (device) {
    case "kiosk-v":
    case "kiosk-h":
      return (
        <KioskNavigation
          value={matchPath?.to}
          navigations={kioskNavigation}
          show={showBottomNavigation}
        />
      )
    case "mobile":
    default:
      return (
        <MobileNavigation
          value={matchPath?.to}
          bottomNavigations={mobileMainNavigations}
          navigations={mobileNavigations}
          show={showBottomNavigation}
        />
      )
  }
}
